<template>
  <div
    class="d-profile-expandable-biography space-bottom-2em"
    @click="toggleIsExpanded"
  >
    <div class="header grid-flex grid-shrink grid-no-response space-bottom-1em">
      <slot name="header" />
    </div>

    <p
      v-if="!isExpanded && !!about.length"
      class="content"
    >
      {{ about | duiTruncate(150) }}
      <a>more</a>
    </p>

    <p
      v-if="isExpanded && !!about.length"
      class="content"
    >
      {{ about }}
    </p>

    <p
      v-if="isExpanded && !about.length && isCurrentUserProfile"
      class="content"
    >
      Your bio is empty <span class="emoji">😱</span>, you can fix that by
      <a :href="editProfileUrl">editing your profile</a>
    </p>

    <div
      v-show="isExpanded"
      class="footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import URLS from '@d-shared/urls/urls';

export default {
  props: {
    about: {
      type: String,
      default: '',
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
    isCurrentUserProfile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isExpanded: false,
    editProfileUrl: URLS.app.userProfile.edit,
  }),
  mounted() {
    this.init();
  },
  methods: {
    toggleIsExpanded() {
      if (this.isAboutEmpty()) return;

      this.$set(this, 'isExpanded', !this.isExpanded);
    },

    init() {
      if (this.isAboutEmpty()) {
        this.$set(this, 'isExpanded', true);
      }
    },

    isAboutEmpty() {
      return this.about.length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-profile-expandable-biography {
  .genres {
    display: flex;
    flex-wrap: wrap;

    > .genre {
      margin: 0 $_1em $_1em 0;
      padding: $_0-5em 0;

      & .button {
        display: inline;
        text-align: left;
        box-decoration-break: clone;
      }
    }
  }

  .avatar {
    border: $border-width-base solid getColor($white);
    border-radius: 50%;
    height: $_6em;
    width: $_6em;
  }
}
</style>
